import { Button, message, Space } from 'antd';
import React, { startTransition, useEffect, useState } from 'react';
import TableWrap from '../../../../components/TableWrap';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { useNavigate } from 'react-router-dom';
import ModalDelete from '../../../../components/Modal/ModalDelete';
import { LearningInterface } from '../../../../interface/learning';
import { deleteTrivia, getAllTrivias } from '../../../../store/trivia/triviaSlice';

const TriviaAccess: React.FC = () => {
  const triviaSlice = useSelector((state: RootState) => state.trivia);
  const { data, loading } = triviaSlice;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<LearningInterface>();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  useEffect(() => {
    try {
      dispatch(getAllTrivias());
    } catch (error) {
      console.log(`${error}`);
    }
  }, [dispatch]);

  const handleEdit = (record) => {
    startTransition(() => {
      navigate(`/trivia-access/${record.id}`);
    });
  };
  const showDeleteModal = (record: any) => {
    setSelectedRecord(record as LearningInterface);
    setIsModalOpen(true);
  };

  const handleDelete = async () => {
    if (selectedRecord) {
      try {
        const result = await dispatch(deleteTrivia({ id: selectedRecord.id }));
        if (result.meta.requestStatus === 'fulfilled') {
          message.success('削除が成功しました!');
          dispatch(getAllTrivias());
        } else {
          message.error('削除に失敗しました。もう一度お試しください。');
        }
      } catch (error) {
        message.error('削除中にエラーが発生しました。');
      } finally {
        setIsModalOpen(false);
      }
    }
  };

  const columns = [
    {
      title: '投稿名',
      dataIndex: 'title',
      key: 'title',
      render: (title: string) => <span>{title}</span>,
    },
    {
      title: '画像',
      dataIndex: 'image',
      key: 'image',
      render: (image: string) => (
        <img
          src={`${process.env.REACT_APP_API_URL}${image}`}
          alt="Post"
          style={{ width: '192px', height: '144px', borderRadius: '4px', objectFit: 'cover' }}
        />
      ),
    },
    {
      title: '',
      key: 'action',
      align: 'center' as const,
      render: (_: any, record) => (
        <Space size="middle">
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/edit.png`} alt="Edit Logo" className="icon-table" />
            }
            onClick={() => handleEdit(record)}
          />
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/delete.png`} alt="Delete Logo" className="icon-table" />
            }
            danger
            onClick={() => showDeleteModal(record)}
          />
        </Space>
      ),
    },
  ];
  const addTrivia = () => {
    startTransition(() => {
      navigate(`/trivia-access/create`);
    });
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div>
      <div className="post-management-header">
        <Button className="btn-black" type="primary" onClick={addTrivia}>
          新作成
        </Button>
      </div>
      <div className="answer-list-container answer-list">
        <TableWrap
          columns={columns}
          data={data.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
          isLoading={loading}
          total={data.length}
          page={currentPage}
          size={pageSize}
          setPage={(page) => setCurrentPage(page)}
          setSize={(newPageSize) => {
            setPageSize(newPageSize);
            setCurrentPage(1);
          }}
        />
      </div>
      <ModalDelete
        isOpen={isModalOpen}
        onOk={handleDelete}
        onCancel={handleCancel}
        content="「質問セット」を削除してもよろしいですか？"
      />
    </div>
  );
};
export default TriviaAccess;
